import { createClient } from "urql"

const makeClient = (url?: string) =>
    createClient({
        url: `${url || process.env.GATSBY_STRAPI_URL}/graphql`
    })

export default makeClient
